// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6363") return "6363.6f0c5429a.bundle.js";
  // return url for filenames based on template
  return "" + (chunkId === "3992" ? "pagerules" : chunkId) + ".6f0c5429a.chunk.js"
}